var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-foot-stat-value",class:{'is-invalid': _vm.invalid},attrs:{"data-type":_vm.type}},[_vm._t("default"),(_vm.invalid)?[_vm._v("n/a")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }